import { api } from "./configs/axiosConfigs"

export const ProductEntryAPI = {
    get: async (data?: object) => {
        const response = await api.get(
            '/product-entry', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    create: async (data: object) => {
        const response = await api.post(
            '/product-entry/register', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },
}